module.exports = __webpack_public_path__ + "static/kayako-logo-2.c19c5f40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/kayako-logo-2.jpg
// module id = 473
// module chunks = 35783957827783